import { render, staticRenderFns } from "./FMCard.vue?vue&type=template&id=2cb97a44&scoped=true&"
import script from "./FMCard.vue?vue&type=script&lang=js&"
export * from "./FMCard.vue?vue&type=script&lang=js&"
import style0 from "./FMCard.vue?vue&type=style&index=0&id=2cb97a44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb97a44",
  null
  
)

export default component.exports